// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import promise from 'es6-promise'
require('es6-promise').polyfill();
import axios from 'axios'
import newsIsTop from './lib/common'
import Swiper from "swiper"
// import 'swiper/dist/idangerous.swiper';
import 'jquery.nicescroll'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.prototype.axios = axios
Vue.use(newsIsTop);
Vue.use(VideoPlayer)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js